const errorLabelClass = `
  text-grey-d80
`

export const getLabelDefault = (error: boolean): string => {
  const defaultLabelClass = `
    text-grey-d80
  `
  return error ? errorLabelClass : defaultLabelClass
}

export const getLabelDisabled = (error: boolean): string => {
  const disabledLabelClass = `
    text-grey-l40
  `
  return error ? errorLabelClass : disabledLabelClass
}
